import _ from "lodash"
import STRING_CONSTANTS from "../../shared/constants/StringConstants"
import {
  INSTALMENT_STATUS,
  INSTALMENT_TYPE,
  PAYMENT_STATUS,
  SCHEME_STATUS,
} from "./constants"
import { getSchemeError } from "./errors"

const PAYABLE_SCHEME_STATUSES = [SCHEME_STATUS.PENDING, SCHEME_STATUS.ACTIVE]

export const canPayOnline = (scheme, metrics) =>
  scheme?.onlinePaymentEnabled === true &&
  PAYABLE_SCHEME_STATUSES.includes(scheme?.status) &&
  metrics?.isDueNow === true &&
  metrics?.currentDue?.status === INSTALMENT_STATUS.DUE

export const buildCheckoutOptions = (
  checkout,
  { onSuccess, onDismiss } = {}
) => ({
  key: checkout.key,
  order_id: checkout.orderId,
  amount: checkout.amount,
  currency: checkout.currency,
  name: checkout.name,
  description: checkout.description,
  prefill: checkout.prefill,
  handler: onSuccess,
  modal: { ondismiss: onDismiss },
})

export const getVerifyPayload = (response) => ({
  razorpayOrderId: response?.razorpay_order_id,
  razorpayPaymentId: response?.razorpay_payment_id,
  razorpaySignature: response?.razorpay_signature,
})

export const getPaymentOutcomeMessage = (response) => {
  switch (response?.status) {
    case PAYMENT_STATUS.PAID:
      return STRING_CONSTANTS.PAYMENT_SUCCESSFUL
    case PAYMENT_STATUS.PROCESSING:
      return response.message || STRING_CONSTANTS.PAYMENT_PROCESSING
    case PAYMENT_STATUS.REFUNDED:
    case PAYMENT_STATUS.REFUND_FAILED:
      return response.message || STRING_CONSTANTS.PAYMENT_REFUNDED
    default:
      return null
  }
}

export const getPayErrorMessage = (
  error,
  fallback = STRING_CONSTANTS.PAYMENT_START_FAILED
) => (_.get(error, "response") ? getSchemeError(error) : fallback)

export const getPaymentFailureMessage = (failure) => {
  const description = failure?.description || failure?.reason
  return description
    ? `Payment failed: ${description}. You can try again.`
    : STRING_CONSTANTS.PAYMENT_FAILED
}

export const isNoResponseError = (error) => !_.get(error, "response")

export const isInstalmentDue = (scheme, installmentNo) =>
  (scheme?.installments || []).some(
    (item) =>
      item.type === INSTALMENT_TYPE.CUSTOMER &&
      item.installmentNo === installmentNo &&
      item.status === INSTALMENT_STATUS.DUE
  )

export const mergePaymentScheme = (previous, next) => ({
  ...next,
  onlinePaymentEnabled: previous?.onlinePaymentEnabled,
})
